<template>
  <div class="food-container">
    <div class="food-list" v-if="data.cal_list_food.length">
      <div
        class="food-item"
        v-for="(item, index) in data.cal_list_food"
        :key="index"
        @click="bindIntoDetail(item)"
      >
        <div class="">
          <div class="super-food-image" v-if="item.is_super == 1">
            <img
              class="super-bg"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/86b0b8cc2309efe2d0fbab3947f9a072.png"
              alt=""
            />
            <img class="image" :src="item.image" alt="" />
          </div>
          <img v-else class="food-image" :src="item.image" alt="" />
        </div>
        <!--  -->
        <div class="item-center">
          <div class="item-name">
            <span class="name">{{ item.food_name }}</span
            ><span
              class="dot"
              :style="{ backgroundColor: getHealthColor(item.health_light) }"
            ></span
            ><span
              class="desc"
              :style="{ color: getHealthColor(item.health_light) }"
              >{{ item.health_light_copywriting }}</span
            >
          </div>
          <div class="unit">
            <span class="calory"
              >{{ item.calory | filterCalory }}{{ item.unit }} </span
            ><span>{{ item.s_light_desc }}</span>
          </div>
        </div>
        <div class="item-right iconfont icon-you"></div>
      </div>
    </div>
    <div v-if="data.user_ingredients_food.length">
      <div class="food-title">自定义食材</div>
      <div class="r-list">
        <div
          class="r-item"
          v-for="(item, index) in data.user_ingredients_food"
          :key="index"
        >
          <span>{{ item.food_name }}</span>
        </div>
      </div>
    </div>
    <div v-if="preferenceData.length">
      <div class="food-title">偏好食材</div>
      <div class="r-list">
        <div
          class="r-item"
          v-for="(item, index) in preferenceData"
          :key="index"
          @click="bindIntoPreferenceDetail(item)"
        >
          <span>{{ item.name }}</span
          ><span class="num">{{ item.count }}次</span>
        </div>
      </div>
    </div>
    <div
      class="not-data"
      v-if="
        loaded &&
        !data.cal_list_food.length &&
        !data.user_ingredients_food.length &&
        !preferenceData.length
      "
    >
      暂无数据
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    loaded: {
      type: Boolean,
      default: false
    },
    preferenceData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      healthData: [
        {
          color: 'rgba(68, 215, 182, 1)',
          text: '放心吃'
        },
        {
          color: 'rgba(247, 181, 0, 1)',
          text: '要少吃'
        },
        {
          color: 'rgba(224, 32, 32, 1)',
          text: '不要吃'
        }
      ]
    }
  },
  filters: {
    filterCalory(num) {
      return parseFloat(num)
    }
  },
  methods: {
    getHealthColor(index) {
      if (index <= 0) {
        index = 1
      }
      return this.healthData[index - 1].color
    },
    getHealthText(index) {
      if (index <= 0) {
        index = 1
      }
      return this.healthData[index - 1].text
    },
    bindIntoDetail(item) {
      if (item.is_super && item.id) {
        this.$router.push({
          path: '/calorie-query/super-food-detail',
          query: {
            id: item.id
          }
        })
      } else if (item.id) {
        this.$router.push({
          path: '/calorie-query/food-info',
          query: {
            foodid: item.id,
            name: item.food_name
          }
        })
      }
    },
    //进入偏好食材
    bindIntoPreferenceDetail(item) {
      if (!item.id) {
        return
      }
      if (item.type == 1) {
        this.$router.push({
          path: '/calorie-query/super-food-detail',
          query: {
            id: item.id
          }
        })
      } else if (item.type == 2) {
        this.$router.push({
          path: '/calorie-query/food-info',
          query: {
            foodid: item.id,
            name: item.food_name
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.food-container {
  .food-list {
    .food-item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .super-food-image {
        position: relative;
        margin-right: 10px;
        width: 36px;
        height: 40px;
        .super-bg {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .image {
          width: 26px;
          height: 20px;
          z-index: 0;
          position: absolute;
          left: 50%;
          bottom: 8px;
          object-fit: contain;
          transform: translate(-50%, 0%);
        }
      }
      .food-image {
        width: 36px;
        height: 36px;
        background: #f9f9f9;
        border-radius: 8px;
        overflow: hidden;
        margin-right: 10px;
        object-fit: contain;
      }
      .item-center {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        margin-right: 10px;
        .item-name {
          display: flex;
          align-items: center;
          .name {
            max-width: 200px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.8);
            line-height: 26px;
            margin-right: 6px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .dot {
            display: inline-block;
            width: 6px;
            height: 6px;
            background: #44d7b6;
            margin-right: 4px;
            border-radius: 50%;
          }
          .desc {
            font-size: 10px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #44d7b6;
            line-height: 14px;
          }
        }
        .unit {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.7);
          line-height: 14px;
          .calory {
            margin-right: 8px;
          }
        }
      }
    }
  }
  .food-title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    margin-bottom: 10px;
  }
  .r-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 24px;
    .r-item {
      height: 28px;
      background: #f7f7f7;
      border-radius: 8px;
      padding: 0px 8px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 26px;
      margin-right: 8px;
      margin-top: 4px;
      margin-bottom: 4px;
      .num {
        margin-left: 8px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
      }
    }
  }
}
.not-data {
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}
</style>
